module.exports = __webpack_public_path__ + "static/img/service_passprime_safe.58d4662e.png";